export const chatboxData = {
  initialText: {
    en: {
      text: " Hi, how can i assist you today? Feel free to ask me about any queries, programs, or curriculum.",
      audio:
        "https://storage.googleapis.com/azure-blob-bucket/tts/speech_1753343482073_02d17af4-2a68-4696-9c81-accfa08e74f9.mp3"
    }
  },
  fallback: {
    error_text: {
      en: {
        answer: "We're having trouble processing your request. Please try again later.",
        audio:
          "https://storage.googleapis.com/azure-blob-bucket/tts/speech_1753343518273_10952706-1039-4b03-8da7-7307d5a32ebd.mp3"
      }
    },
    error_voice: {
      en: {
        answer: "We're having trouble processing your request. Please try again later.",
        audio:
          "https://storage.googleapis.com/azure-blob-bucket/tts/speech_1753343518273_10952706-1039-4b03-8da7-7307d5a32ebd.mp3"
      }
    },
    offline_voice: {
      en: {
        answer: "It seems you're offline. Please check your internet connection and try again.",
        audio:
          "https://storage.googleapis.com/azure-blob-bucket/tts/speech_1753343575232_64bdc202-1bca-4a55-9953-b811ff03a1a2.mp3"
      }
    },
    offline_text: {
      en: {
        answer: "It seems you're offline. Please check your internet connection and try again.",
        audio:
          "https://storage.googleapis.com/azure-blob-bucket/tts/speech_1753343575232_64bdc202-1bca-4a55-9953-b811ff03a1a2.mp3"
      }
    }
  }
};
